import React, { Fragment, useEffect, useState } from "react";
import { useFormik } from "formik";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { formikLogin } from "./Constant";
import { signIn } from "../../api/auth";
import { useDispatch } from "react-redux";
import { userActions } from "../../context/reducers/user";
import { decryptData } from "../../utils/helper";
import { failed, success } from "../../utils/Tostify";
import Loader from "../../components/Loader/Loader";
import "../../custome.style.css";
import { Button, Form, FormGroup, Input } from "reactstrap";
import { platformLayout } from "../../utils/constants";
import { maskEmail } from "../../utils/common";

const SignInWithTempPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const queryParams = new URLSearchParams(window.location.search);
    const email = queryParams.get('email')?.replace(/ /g, "+");
    const decryptedEmail = JSON.parse(atob(email));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loginFormik = useFormik({
        ...formikLogin,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                res = await signIn({ values, dispatch });
                localStorage.setItem("REACT_APP_ENCRYPT_KEY",res.data.ENCRYPT_KEY);
                localStorage.setItem("REACT_APP_ADOBE_READER_CLIENT_ID",res.data.ADOBE_FRONT_KEY);
                const responseData = decryptData(res?.data.encryptedResponse);
                if (res?.status === "SUCCESS") {
                    setIsLoading(false);
                    if(responseData?.isPasswordTemp){
                        navigate(`/reset-password?email=${email}`, {state : {isPasswordTemp: responseData?.isPasswordTemp}});
                    }else{
                        success(res?.message);
                        const defaultOrg = responseData?.organizations?.find((org)=> org?.organizationId?._id === responseData?.defaultLogInOrg);
                        const currentHospitalId = defaultOrg?.defaultClinic?._id;
                        localStorage.setItem("currentHospitalId", currentHospitalId);
                        localStorage.setItem("currentOrgId", responseData?.defaultLogInOrg);
                        localStorage.setItem("userRole", responseData?.defaultRole?.value?.portalLayout);
                        localStorage.setItem("roleId", responseData?.defaultRole?.value?._id);
                        dispatch(userActions.loginSuccess(responseData));
                        if(responseData?.defaultRole?.value?.portalLayout === platformLayout.Platform){
                            navigate("/super-admin/home");
                        }else{
                            navigate("/app/home");
                        }
                    }
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    useEffect(() => {
        if(email){
          loginFormik.setFieldValue("email", decryptedEmail);
        }
      }, [email]);
    return (
        <Fragment>
            {isLoading ? <Loader /> : null}
            <div className="page-wrapper full-page">
                <div className="header-wrapper w-nav">
                    <div className="container-default w-container">
                        <div className="header-content-wrapper">
                            <div className="header-middle header-v3">
                                <a>
                                    <img src="/assets/icons/group_logo_carematics.svg" alt="text_logo" className="logo_png" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section sign-in-section">
                    <div className="image-container sign-in-section">
                        <div className="image-wrapper shape section-hero---sign-in---shape-01">
                            <img
                                src="/assets/icons/WELCOME-YELLOW-CIRCLE.svg"
                                alt=""
                            />
                        </div>
                        <div className="position-absolute sign-in-shape-wrapper">
                            <div className="image-wrapper shape section-hero---sign-in---shape-02">
                                <img
                                    src="/assets/icons/WELCOME-BLUE-LINES.svg"
                                    alt=""
                                />
                            </div>
                            <div className="image-wrapper transform-origin-bottom">
                                <img
                                    src="/assets/icons/WELCOME-RED-CIRCLE.svg"
                                    alt=""
                                />
                            </div>
                            <div className="image-wrapper">
                                <img
                                    src="/assets/icons/WELCOME-RECTANGLE.svg"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                    <div className="container-default z-index-1 width-100 w-container">
                        <div className="inner-container _640px center">
                            <div className="text-center mg-bottom-48px">
                                <h1 className="display-1 mg-bottom-8px welcom_blk">
                                Register Account
                                </h1>
                                <p className="color-neutral-700 mg-bottom-0 welcom_desc">
                                    Fill temporary password to reset password and register account.
                                </p>
                            </div>
                            <div className="card sign-up-form shadow-02 w-form login_form">
                                <Form className="form_block" onSubmit={loginFormik.handleSubmit}>
                                    <FormGroup className="spacing_three">
                                        <Input
                                            id="exampleEmail"
                                            name="email"
                                            placeholder="Email"
                                            type="email"
                                            disabled={email ? true : false}
                                            value={email ? maskEmail(loginFormik.values.email) : loginFormik.values.email}
                                            onChange={loginFormik.handleChange}
                                            required=""
                                        />
                                        <img src="/assets/icons/welcom-email.svg" alt="text_logo" />
                                        {loginFormik.touched["email"] && loginFormik.errors["email"] ? <span style={{color: "red"}}>{loginFormik.errors["email"]}</span> : null}
                                    </FormGroup>
                                    {loginFormik.values.showPassword && <FormGroup className="spacing_three_password">
                                        <Input
                                            id="examplePassword"
                                            name="password"
                                            placeholder="Temporary Password"
                                            type="password"
                                            value={loginFormik.values.password}
                                            onChange={loginFormik.handleChange}
                                            required=""
                                        />
                                        <img src="/assets/icons/Lock.svg" alt="text_logo" />
                                        <i className="fa fa-eye" onClick={()=> loginFormik.setFieldValue("showPassword", false)}></i>
                                        {loginFormik.touched["password"] && loginFormik.errors["password"] ? <span style={{color: "red"}}>{loginFormik.errors["password"]}</span> : null}
                                    </FormGroup>}
                                    {!loginFormik.values.showPassword && < FormGroup className="spacing_three_password">
                                        <Input
                                            id="examplePassword"
                                            name="password"
                                            placeholder="Temporary Password"
                                            type="text"
                                            value={loginFormik.values.password}
                                            onChange={loginFormik.handleChange}
                                            required=""
                                        />
                                        <img src="/assets/icons/Lock.svg" alt="text_logo" />
                                        <i className="fa fa-eye-slash" onClick={()=> loginFormik.setFieldValue("showPassword", true)}></i>
                                        {loginFormik.errors["password"] ? <span style={{color: "red"}}>{loginFormik.errors["password"]}</span> : null}
                                    </FormGroup>}
                                    <Button type="submit" className="spacing_four">
                                        Submit
                                    </Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <footer>
                    <p>Copyright © 2024 AimCare LLC</p>
                </footer>
            </div>
        </Fragment>
    );
};

export default SignInWithTempPassword;
